module.exports = __webpack_public_path__ + "static/media/bill-v2.744ba4a5.jpg";